import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext'; // Import useAuth
import { TextField, Button, Typography, Container, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import FormCard from './FormCard';

function ImovelForm({ onImovelAdded, initialData, onCancelEdit }) {
  const { user } = useAuth(); // Get user from context
  const [id, setId] = useState(null);
  const [empresa_id, setEmpresaId] = useState('');
  const [descricao, setDescricao] = useState('');
  const [numero, setNumero] = useState('');
  const [bloco, setBloco] = useState('');
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    // Carregar lista de empresas para o select apenas se o usuario for admin
    if (user && user.tipo_usuario === 'admin') {
      api.get('/empresas')
        .then(response => {
          const list = response.data?.data || response.data;
          setEmpresas(Array.isArray(list) ? list : []);
        })
        .catch(error => {
      console.error('Erro ao buscar empresas:', error);
        });
    }

    if (initialData) {
      setId(initialData.id);
      setEmpresaId(initialData.empresa_id);
      setDescricao(initialData.descricao);
      setNumero(initialData.numero);
      setBloco(initialData.bloco);
    } else {
      clearForm();
    }
  }, [initialData, user]); // Adicionar user como dependencia

  const clearForm = () => {
    setId(null);
    setEmpresaId('');
    setDescricao('');
    setNumero('');
    setBloco('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const imovelData = {
      empresa_id: user.tipo_usuario === 'admin' ? empresa_id : user.empresa_id, // Define empresa_id com base no tipo de usuario
      descricao,
      numero,
      bloco,
    };

    if (id) {
      // Modo de edicao
      api.put(`/imoveis/${id}`, imovelData)
        .then(response => {
          console.log('Im&oacute;vel atualizado:', response.data);
          clearForm();
          onImovelAdded();
          onCancelEdit();
        })
        .catch(error => {
          console.error('Erro ao atualizar im&oacute;vel:', error);
        });
    } else {
      // Modo de criacao
      api.post('/imoveis', imovelData)
        .then(response => {
          console.log('Im&oacute;vel adicionado:', response.data);
          clearForm();
          onImovelAdded();
        })
        .catch(error => {
          console.error('Erro ao adicionar im&oacute;vel:', error);
        });
    }
  };

  return (
    <Container maxWidth="sm">
      <FormCard component="form" onSubmit={handleSubmit}>
        <Typography variant="h5" gutterBottom>
          {id ? 'Editar Imóvel' : 'Adicionar Novo Imóvel'}
        </Typography>
        {(user && user.tipo_usuario === 'admin') && (
          <FormControl fullWidth margin="normal" required>
            <InputLabel id="empresa-select-label">Empresa</InputLabel>
            <Select
              labelId="empresa-select-label"
              value={empresa_id}
              label="Empresa"
              onChange={(e) => setEmpresaId(e.target.value)}
            >
              {(Array.isArray(empresas) ? empresas : []).map((emp) => (
                <MenuItem key={emp.id} value={emp.id}>
                  {emp.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <TextField
          label="Descrição"
          variant="outlined"
          fullWidth
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          label="Número"
          variant="outlined"
          fullWidth
          value={numero}
          onChange={(e) => setNumero(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          label="Bloco"
          variant="outlined"
          fullWidth
          value={bloco}
          onChange={(e) => setBloco(e.target.value)}
          margin="normal"
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ mt: 2, mr: 2 }}
        >
          {id ? 'Atualizar Imóvel' : 'Adicionar Imóvel'}
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          sx={{ mt: 2 }}
          onClick={onCancelEdit}
        >
          Cancelar
        </Button>
      </FormCard>
    </Container>
  );
}

export default ImovelForm;
